export default __webpack_public_path__ + "static/media/Mall Music Muzak - Mall Of 1974 - 07 Phonebooth Call To Home.f6c8ab5d.mp3";